const _temp0 = require("url:../images/logos/canmore.png");

const _temp1 = require("url:../images/logos/coral-gables.png");

const _temp2 = require("url:../images/logos/gloucester-longbeach.png");

const _temp3 = require("url:../images/logos/gloucester.png");

const _temp4 = require("url:../images/logos/melbourne.svg");

const _temp5 = require("url:../images/logos/pittsburgh.svg");

module.exports = {
  "canmore":   {
    "png": _temp0
  },
  "coral-gables":   {
    "png": _temp1
  },
  "gloucester-longbeach":   {
    "png": _temp2
  },
  "gloucester":   {
    "png": _temp3
  },
  "melbourne":   {
    "svg": _temp4
  },
  "pittsburgh":   {
    "svg": _temp5
  }
}